import { Accordion, AccordionTab } from "primereact/accordion";
import { RadioButton } from "primereact/radiobutton";
import { TabPanel } from "primereact/tabview";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CardCurso from "../../components/Cards/CardCurso";
import CardCursoExplorar from "../../components/Cards/CardCursoExplorar";
import CardPrograma from "../../components/Cards/CardPrograma";
import CardProgramaExplorar from "../../components/Cards/CardProgramaExplorar";
import EmptyDashboard from "../../components/Empty/EmptyDashboard";
import InputZegel from "../../components/Inputs/InputZegel";
import MultiselectZegel from "../../components/Multiselect/MultiselectZegel";
import TabZal from "../../components/TabZal/TabZal";
import { buscarConfiguracion } from "../../helpers/helpers";
import useAlumno from "../../hooks/useAlumno";
import {
  ListarCursos,
  ObtenerEncuestaPuntuacion,
  ObtenerListaCategorias,
} from "../../services/CursoService";
import { ListarProgramas } from "../../services/ProgramaService";
import {
  ObtenerCursosPorUsuario,
  ObtenerProgramasPorUsuario,
} from "../../services/UsuarioService";

import iconoFiltro from "../../assets/img/filtro-icono.png";

import { useNavigate } from "react-router-dom";
import { PrivateRoutes } from "../../routes/routes";

import "../Dashboard/Dashboard.scss";
import LoadingGlobal from "../components/LoadingGlobal/LoadingGlobal";

const Dashboard = () => {
  const navigate = useNavigate();
  // const [activosChecked, setActivosChecked] = useState("curso-activo");
  // const [finalizadoChecked, setFinalizadoChecked] = useState("");
  // const [explorarChecked, setExplorarChecked] = useState("");
  const expandIcontemplate = (
    <span className="icon-acordeon">
      <img
        alt="Ícono de filtro"
        height={7}
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjUiIHZpZXdCb3g9IjAgMCA2IDUiPgogIDxwYXRoIGlkPSJtdWx0aW1lZGlhIiBkPSJNNC45MywyLjg4Mi4yNTMuMDI1QS4xOC4xOCwwLDAsMCwuMDg2LjAxNi4xNDIuMTQyLDAsMCwwLDAsLjE0M1Y1Ljg1N2EuMTQyLjE0MiwwLDAsMCwuMDg2LjEyN0EuMTguMTgsMCwwLDAsLjE2MSw2YS4xNzcuMTc3LDAsMCwwLC4wOTItLjAyNUw0LjkzLDMuMTE4YS4xMzQuMTM0LDAsMCwwLDAtLjIzNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNSkgcm90YXRlKC05MCkiIGZpbGw9IiMyYjJiMmIiLz4KPC9zdmc+Cg=="
      ></img>
    </span>
  );
  const CollapseIcontemplate = (
    <span className="icon-acordeon">
      <img
        alt="Ícono de filtro"
        height={7}
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjUiIHZpZXdCb3g9IjAgMCA2IDUiPgogIDxwYXRoIGlkPSJtdWx0aW1lZGlhIiBkPSJNNC45MywyLjg4Mi4yNTMuMDI1QS4xOC4xOCwwLDAsMCwuMDg2LjAxNi4xNDIuMTQyLDAsMCwwLDAsLjE0M1Y1Ljg1N2EuMTQyLjE0MiwwLDAsMCwuMDg2LjEyN0EuMTguMTgsMCwwLDAsLjE2MSw2YS4xNzcuMTc3LDAsMCwwLC4wOTItLjAyNUw0LjkzLDMuMTE4YS4xMzQuMTM0LDAsMCwwLDAtLjIzNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNSkgcm90YXRlKC05MCkiIGZpbGw9IiMyYjJiMmIiLz4KPC9zdmc+Cg=="
      ></img>
    </span>
  );

  const {
    perfil,
    configuraciones,
    activosChecked,
    setActivosChecked,
    finalizadoChecked,
    setFinalizadoChecked,
    explorarChecked,
    setExplorarChecked,
    indexActiveCursos,
    setIndexActiveCursos,
    indexTabPrincipal,
    indexTabSecundario,
    setIndexTabPrincipal,
    setIndexTabSecundario
  } = useAlumno();
  const [listaCursos, setListaCursos] = useState(null);
  const [listaProgramas, setListaProgramas] = useState(null);
  const [cursosActivos, setCursosActivos] = useState(null);
  const [programasActivos, setProgramasActivos] = useState(null);
  const [cursosFianlizados, setCursosFianlizados] = useState(null);
  const [listaCursosFinalizadosProg, setListaCursosFinalizadosProg] = useState([]);
  const [programasFinalizados, setProgramasFinalizados] = useState(null);
  const [listaCursosExplorar, setListaCursosExplorar] = useState(null);
  const [CursosFinalizados, setCursosFinalizados] = useState(null);

  const [listaCursosExplorarBackup, setListaCursosExplorarBackup] =
    useState(null);

  const [listaProgramasExplorar, setListaProgramasExplorar] = useState(null);
  // const [indexTabPrincipal, setIndexTabPrincipal] = useState(0);
  // const [indexTabSecundario, setIndexTabSecundario] = useState(0);
  const [listaCategorias, setListaCategorias] = useState(null);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [ordenFiltroSeleccionado, setOrdenFiltroSeleccionado] = useState(null);
  const [busquedaCurso, setBusquedaCurso] = useState(null);
  const [filterMenu, setFilterMenu] = useState(false);
  const [listaCursosProgramasPersona, setListaCursosProgramasPersona] =
    useState(null);
  const filtroOrden = [
    { name: "A-Z", code: "AZ" },
    { name: "Mayor duración", code: "MD" },
    { name: "Mayor puntuación", code: "MP" },
    { name: "Cursos nuevos", code: "CN" },
  ];

  const [VentanaCarga, setVentanaCarga] = useState(false);
  const [EncuestaPuntuacion, setEncuestaPuntuacion] = useState(null);
  const [loadingGlobal, setLoadingGlobal] = useState(false);

  useEffect(() => {
    if (categoriaSeleccionada && categoriaSeleccionada.length > 0) {
      const temp = listaCursosExplorarBackup.filter((item) =>
        categoriaSeleccionada.includes(item.idCategoria)
      );

      setListaCursosExplorar(temp);
    } else {
      setListaCursosExplorar(listaCursosExplorarBackup);
    }
  }, [categoriaSeleccionada]);

  useEffect(() => {
    if (busquedaCurso && busquedaCurso.length > 0) {
      if (busquedaCurso.length > 0) {
        let temp = listaCursosExplorarBackup.filter((x) =>
          x.nombre.toLowerCase().includes(busquedaCurso.toLowerCase())
        );
        setListaCursosExplorar(temp);
      }
    } else {
      setListaCursosExplorar(listaCursosExplorarBackup);
    }
  }, [busquedaCurso]);

  useEffect(() => {
    if (ordenFiltroSeleccionado) filtrarCursos(ordenFiltroSeleccionado);
  }, [ordenFiltroSeleccionado]);

  const filtrarCursos = (filtros) => {
    let temp = [...listaCursosExplorar];
    filtros.forEach((item) => {
      if (item.code == "AZ") {
        temp.sort((a, b) => a.nombre.localeCompare(b.nombre));
      }
      if (item.code == "MD") {
        //temp.sort((a, b) => b.duracion.localeCompare(a.duracion));
        temp.sort((a, b) => {
          const duracionA = parseFloat(a.duracion);
          const duracionB = parseFloat(b.duracion);
          return duracionB - duracionA;
        });
      }
      if (item.code == "CN") {
        temp.sort(
          (a, b) => new Date(b.fechaRegistro) - new Date(a.fechaRegistro)
        );
      }
      if (item.code == "MP") {
        if (EncuestaPuntuacion != null)
          temp.sort((a, b) => {
            const resultadoA = EncuestaPuntuacion.find(
              (item) => item.idCurso === a.idCurso
            );
            const resultadoB = EncuestaPuntuacion.find(
              (item) => item.idCurso === b.idCurso
            );
            const resultadoAValue = resultadoA
              ? resultadoA.segundaEncuestaCursoResultado1
              : -1;
            const resultadoBValue = resultadoB
              ? resultadoB.segundaEncuestaCursoResultado1
              : -1;
            return resultadoBValue - resultadoAValue;
          });
      }
    });

    setListaCursosExplorar(temp);
  };

  useEffect(() => {
    setLoadingGlobal(true)
    let jwt = window.localStorage.getItem("jwt");
    ListarCursos({ jwt }).then((data) => setListaCursos(data))
    ListarProgramas({ jwt }).then((data) => setListaProgramas(data));
    const GetCategorias = async () => await ObtenerListaCategorias({ jwt }).then((data) => setListaCategorias(data));
    if (!listaCategorias) GetCategorias();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoadingGlobal(true);
  //     let jwt = window.localStorage.getItem("jwt");
  //     try {
  //       const cursos = await ListarCursos({ jwt });
  //       setListaCursos(cursos);
  //       const programas = await ListarProgramas({ jwt });
  //       setListaProgramas(programas);
  //       if (!listaCategorias) {
  //         const categorias = await ObtenerListaCategorias({ jwt });
  //         setListaCategorias(categorias);
  //       }
  //     } catch (error) {
  //       console.error("Error al cargar datos:", error);
  //     } 
  //   };
  
  //   fetchData();
  // }, []);
  


  const listarCursosAlumnos = (id) => {
    let jwt = window.localStorage.getItem("jwt");
    let idUsuario = id;
    ObtenerCursosPorUsuario({ jwt, idUsuario }).then((data) => {
      setListaCursosProgramasPersona(
        data.filter((x) => x.idPersonaPrograma !== null)
      );
      let tempActivos = data.filter((x) => (x.idEstado == 3 && (!x.fechaVigenciaMembresia ||  new Date(x.fechaVigenciaMembresia) >= new Date())) || (x.idEstado == 2 && 
        (new Date(x.fechaVigencia) >= new Date() || (x.fechaAmpliacionCurso && new Date(x.fechaAmpliacionCurso) >= new Date()))
        && (!x.fechaVigenciaMembresia ||  new Date(x.fechaVigenciaMembresia) >= new Date())
        ));
      setCursosFinalizados(tempActivos)
      var tempActivosString = JSON.stringify(tempActivos);
      // Guarda la cadena JSON en localStorage
      localStorage.setItem('Cursos', tempActivosString);

      if (
        tempActivos.filter((x) => x.idEstado == 3).length > 0 &&
        !perfil.onboardingCurso
      ) {
        navigate(
          "/" +
          PrivateRoutes.HOME +
          "/BienvenidaCurso/" +
          tempActivos.filter((x) => x.idEstado == 3)[0].idPersonaCurso
        );
        setVentanaCarga(true);
      } else {
        setVentanaCarga(true);
      }
      let tempFinalizados = data.filter((x) => x.idEstado == 1 || (x.idEstado == 2 
              && 
              ((new Date(x.fechaVigencia) < new Date() && !x.fechaAmpliacionCurso) || (x.fechaAmpliacionCurso && new Date(x.fechaAmpliacionCurso) < new Date()))
      ) || (x.fechaVigenciaMembresia &&  new Date(x.fechaVigenciaMembresia) < new Date())
              );

      setCursosActivos(tempActivos.filter((x) => x.idPersonaPrograma == null));
      setCursosFianlizados(
        tempFinalizados.filter((x) => x.idPersonaPrograma == null)
      );
      setListaCursosFinalizadosProg(tempFinalizados.filter((x) => x.idPersonaPrograma != null))

      if(EncuestaPuntuacion== null){
        ObtenerEncuestaPuntuacion({ jwt }).then((data) => {
          setEncuestaPuntuacion(data);
        });
      } 
      let programasPersona = data.filter((x) => x.idPersonaPrograma !== null)
      if (programasPersona) {
        listarProgramasAlumnos(perfil.idUsuario,programasPersona);
      }
    });

    
  };

  const listarProgramasAlumnos = (id,programasPersona) => {
    

    let jwt = window.localStorage.getItem("jwt");
    let idPersona = id;
    ObtenerProgramasPorUsuario({ jwt, idPersona }).then((data) => {

      let tempProgramasAlumnos = [];
      data.map((item, i) => {
        let itemsCursoPrograma = programasPersona.filter(x => x.idPersonaPrograma == item.idPersonaPrograma)
        let itemsCursoProgramaFinalizados = listaCursosFinalizadosProg.filter(x => x.idPersonaPrograma == item.idPersonaPrograma)
        let progFinalizado = false;
        if (itemsCursoProgramaFinalizados.length == itemsCursoPrograma.length) progFinalizado = true;
        let temp = { idPersonaPrograma: item.idPersonaPrograma, finalizado: progFinalizado }
        tempProgramasAlumnos.push(temp)
      })

      let tempActivos = data.filter((x) => tempProgramasAlumnos.some(y => y.idPersonaPrograma == x.idPersonaPrograma && y.finalizado == false));
      var tempActivosStringRecuperado = localStorage.getItem('Cursos');
      var tempActivosRecuperado = JSON.parse(tempActivosStringRecuperado);
      localStorage.removeItem('Cursos');
      var CantidadCursos = 0;
      for (var i = 0; i < tempActivosRecuperado?.length; i++) {
          if (tempActivosRecuperado[i].idPersonaPrograma === null) {
            CantidadCursos++;
          }
      }

      if (
        tempActivos.filter((x) => x.idEstado == 3).length > 0 &&
        !perfil.onboardingPrograma && CantidadCursos === 0
      ) {
        navigate(
          "/" +
          PrivateRoutes.HOME +
          "/BienvenidaPrograma/" +
          tempActivos.filter((x) => x.idEstado == 3)[0].idPersonaPrograma
        );
        setVentanaCarga(true);
      } else {
        if( tempActivos.filter((x) => x.idEstado == 3).length > 0 && !perfil.onboardingPrograma && !perfil.onboardingCurso && !perfil.onboarding && CantidadCursos){
          navigate(
            "/" +
            PrivateRoutes.HOME +
            "/BienvenidaCursoPrograma/" +
            tempActivos.filter((x) => x.idEstado == 3)[0].idPersonaPrograma
          );
          setVentanaCarga(true);
        }else{
          setVentanaCarga(true);

        }
      } 
      let tempFinalizados = data.filter((x) => x.idEstado == 1 || (tempProgramasAlumnos.some(y => y.idPersonaPrograma == x.idPersonaPrograma && y.finalizado == true)));
   
      setProgramasActivos(tempActivos);
      setProgramasFinalizados(tempFinalizados);
      setLoadingGlobal(false)
    });
  };

  useEffect(() => {
    if (listaCursos && cursosActivos) {
      const idsFiltro = cursosActivos.map((item) => item.idCurso);

      const resultadoFiltro = listaCursos.filter(
        (curso) => !idsFiltro.includes(curso.idCurso)
      );

      if (resultadoFiltro.length > 0) {
        const resultadoVenta = resultadoFiltro.filter(
          (curso) => curso.idEstado == 3
        );
        setListaCursosExplorar(resultadoVenta);
        setListaCursosExplorarBackup(resultadoVenta);
      }
    }
  }, [cursosActivos, listaCursos]);

  useEffect(() => {
    if (programasActivos && listaProgramas) {
      const idsFiltro = programasActivos.map((item) => item.idPrograma);

      const resultadoFiltro = listaProgramas.filter(
        (programa) => !idsFiltro.includes(programa.idPrograma)
      );

      if (resultadoFiltro.length > 0) {
        const resultadoVenta = resultadoFiltro.filter(
          (programa) => programa.activo == true
        );
        setListaProgramasExplorar(resultadoVenta);
      }
    }
  }, [programasActivos, listaProgramas]);

  
  // useEffect(() => {
  //   if (perfil) {
  //     if (perfil.idUsuario) listarCursosAlumnos(perfil.idUsuario);
  //   }
  // }, [perfil]);

  // useEffect(() => {
  //   if (perfil) {

  //     if (perfil.idUsuario && listaCursosProgramasPersona) {

  //       listarProgramasAlumnos(perfil.idUsuario);
  //     }
  //   }
  // }, [perfil, listaCursosProgramasPersona]);

  const fetchData = async () => {
    try {
      if (perfil && perfil.idUsuario) {
        listarCursosAlumnos(perfil.idUsuario);
      }
    } catch (error) {
      console.error("Error al obtener cursos:", error);
    }
  };
  
  useEffect(() => {
      fetchData();
  }, [perfil,listaCursosProgramasPersona!=null]);
  

  /* const ObtenerEncuestaPuntuacion =() =>{
    let jwt = window.localStorage.getItem("jwt");
    ObtenerEncuestaPuntuacion({ jwt }).then((data) => {
    });
  } */

  return (
    <div>
      <LoadingGlobal loadingGlobal={loadingGlobal} />
      {VentanaCarga ? (
        <div className="container dashboard zal-home-dashboard">
          <div className="home-dashboard-inicio">Inicio</div>
          <div className="home-dashboard-body">
            <div className="body-menu">
              <Accordion
                key={0}
                activeIndex={indexActiveCursos}
                expandIcon={expandIcontemplate}
                collapseIcon={CollapseIcontemplate}
                onTabOpen={(e) => {
                  if (e.index === 0) {
                    setActivosChecked("curso-activo");
                    setFinalizadoChecked("");
                    setExplorarChecked("");
                  } else if (e.index === 1) {
                    setActivosChecked("");
                    setFinalizadoChecked("curso-finalizado");
                    setExplorarChecked("");
                  } else {
                    setActivosChecked("");
                    setFinalizadoChecked("");
                    setExplorarChecked("curso-explorado");
                  }
                }}
                onTabChange={(e) => setIndexActiveCursos(e.index)}
              >
                <AccordionTab key={1} header="Activos" headerStyle={{ fontSize: 30 }}>
                  <div className="menu-content-activos flex flex-column gap-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        className="z-radio-personalizado"  
                        inputId={"Cursos-activos"}
                        name="groupButton"
                        value={"curso-activo"}
                        onChange={(e) => setActivosChecked(e.value)}
                        checked={activosChecked === "curso-activo"}
                      />
                      <label
                        htmlFor={"Cursos-activos"}
                        className="ml-2"
                        style={{ fontSize: 12, fontWeight: "bold" }}
                      >
                        Cursos ({cursosActivos ? cursosActivos.length : 0})
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        className="z-radio-personalizado"  
                        inputId={"Programas-activos"}
                        name="groupButton"
                        value={"programa-activo"}
                        onChange={(e) => setActivosChecked(e.value)}
                        checked={activosChecked === "programa-activo"}
                      />
                      <label
                        htmlFor={"Programas-activos"}
                        className="ml-2"
                        style={{ fontSize: 12, fontWeight: "bold" }}
                      >
                        Programas (
                        {programasActivos ? programasActivos.length : 0})
                      </label>
                    </div>
                  </div>
                </AccordionTab>
                <AccordionTab key={2} header="Finalizados">
                  <div className="menu-content-activos flex flex-column gap-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        className="z-radio-personalizado"  
                        inputId={"Cursos-finalizados"}
                        name="groupButton"
                        value={"curso-finalizado"}
                        onChange={(e) => setFinalizadoChecked(e.value)}
                        checked={finalizadoChecked === "curso-finalizado"}
                      />
                      <label
                        htmlFor={"Cursos-finalizados"}
                        className="ml-2"
                        style={{ fontSize: 12, fontWeight: "bold" }}
                      >
                        Cursos (
                        {cursosFianlizados ? cursosFianlizados.length : 0})
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        className="z-radio-personalizado"  
                        inputId={"Programas-finalizados"}
                        name="groupButton"
                        value={"programa-finalizado"}
                        onChange={(e) => setFinalizadoChecked(e.value)}
                        checked={finalizadoChecked === "programa-finalizado"}
                      />
                      <label
                        htmlFor={"Programas-finalizados"}
                        className="ml-2"
                        style={{ fontSize: 12, fontWeight: "bold" }}
                      >
                        Programas (
                        {programasFinalizados ? programasFinalizados.length : 0}
                        )
                      </label>
                    </div>
                  </div>
                </AccordionTab>
                <AccordionTab key={3} header="Explorar">
                  <div className="menu-content-activos flex flex-column gap-2">
                    <div className="flex align-items-center">
                      <RadioButton
                        className="z-radio-personalizado"  
                        inputId={"Cursos-explorar"}
                        name="groupButton"
                        value={"curso-explorado"}
                        onChange={(e) => setExplorarChecked(e.value)}
                        checked={explorarChecked === "curso-explorado"}
                      />
                      <label
                        htmlFor={"Cursos-explorar"}
                        className="ml-2"
                        style={{ fontSize: 12, fontWeight: "bold" }}
                      >
                        Cursos
                      </label>
                    </div>
                    <div className="flex align-items-center">
                      <RadioButton
                        className="z-radio-personalizado"  
                        inputId={"Programas-explorar"}
                        name="groupButton"
                        value={"programa-explorado"}
                        onChange={(e) => setExplorarChecked(e.value)}
                        checked={explorarChecked === "programa-explorado"}
                      />
                      <label
                        htmlFor={"Programas-explorar"}
                        className="ml-2"
                        style={{ fontSize: 12, fontWeight: "bold" }}
                      >
                        Programas
                      </label>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
            <div className="body-content">
              {activosChecked == "curso-activo" && cursosActivos ? (
                cursosActivos.length > 0 ? (
                  <div
                    className="content-cursosPrograma"
                    style={{
                      paddingLeft: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                    }}
                  >
                    {cursosActivos.map((item, i) => {
                      console.log(item,i);
                      
                      return <CardCurso key={i} curso={item}></CardCurso>;
                    })}
                  </div>
                ) : (
                  activosChecked == "curso-activo" && (
                    <EmptyDashboard tipo="Aún no has comprado ningún curso"></EmptyDashboard>
                  )
                )
              ) : (
                activosChecked == "curso-activo" && (
                  <EmptyDashboard tipo="Cargando..."></EmptyDashboard>
                )
              )}
              {activosChecked == "programa-activo" &&
                programasActivos &&
                programasActivos.length > 0 ? (
                <div
                  className="content-programaTab"
                  style={{ paddingLeft: 8, paddingRight: 8, paddingBottom: 8 }}
                >
                  <Accordion
                    /* activeIndex={0} */
                    expandIcon={expandIcontemplate}
                    collapseIcon={CollapseIcontemplate}
                    className="acordeon-programas"
                  >
                    {programasActivos.map((item, i) => {
                      return (
                        <AccordionTab
                          key={1}
                          style={{ width: "100%" }}
                          header={item.programa.nombre}
                        >
                          <div
                            className="content-cursosPrograma"
                            style={{
                              // paddingLeft: 8,
                              // paddingRight: 8,
                              paddingBottom: 8,
                            }}
                          >
                            {listaCursosProgramasPersona &&
                              listaCursosProgramasPersona
                                .filter(
                                  (x) =>
                                    x.idPersonaPrograma ==
                                    item.idPersonaPrograma
                                )
                                .map((curso, j) => {
                                  return (
                                    <CardPrograma
                                      key={i}
                                      curso={curso}
                                      personaPrograma={item.idPersonaPrograma}
                                      idPrograma={item.idPrograma}
                                    ></CardPrograma>
                                  );
                                })}
                          </div>
                        </AccordionTab>
                      );
                    })}
                  </Accordion>
                </div>
              ) : (
                activosChecked == "programa-activo" && (
                  <EmptyDashboard tipo="Aún no has comprado ningún programa"></EmptyDashboard>
                )
              )}
              {finalizadoChecked == "curso-finalizado" &&
                cursosFianlizados &&
                cursosFianlizados.length > 0 ? (
                <div
                  className="content-cursosPrograma"
                  style={{ paddingLeft: 8, paddingRight: 8, paddingBottom: 8 }}
                >
                  {cursosFianlizados.map((item, i) => {
                    return <CardCurso key={i} curso={item}></CardCurso>;
                  })}
                </div>
              ) : (
                finalizadoChecked == "curso-finalizado" && (
                  <EmptyDashboard tipo="Aún no has finalizado ningún curso"></EmptyDashboard>
                )
              )}
              {finalizadoChecked == "programa-finalizado" &&
                programasFinalizados &&
                programasFinalizados.length > 0 ? (
                <div
                  className="content-programaTab"
                  style={{ paddingLeft: 8, paddingRight: 8, paddingBottom: 8 }}
                >
                  <Accordion
                    /* activeIndex={0} */
                    expandIcon={expandIcontemplate}
                    collapseIcon={CollapseIcontemplate}
                    className="acordeon-programas"
                  >
                    {programasFinalizados.map((item, i) => {
                      return (
                        <AccordionTab
                          key={1}
                          style={{ width: "100%" }}
                          header={item.programa.nombre}
                        >
                          <div
                            className="content-cursosPrograma"
                            style={{
                              // paddingLeft: 8,
                              // paddingRight: 8,
                              paddingBottom: 8,
                            }}
                          >
                            {listaCursosProgramasPersona &&
                              listaCursosProgramasPersona
                                .filter(
                                  (x) =>
                                    x.idPersonaPrograma ==
                                    item.idPersonaPrograma
                                )
                                .map((curso, j) => {
                                  return (
                                    <CardPrograma
                                      key={i}
                                      curso={curso}
                                      personaPrograma={item.idPersonaPrograma}
                                      idPrograma={item.idPrograma}
                                    ></CardPrograma>
                                  );
                                })}
                          </div>
                        </AccordionTab>
                      );
                    })}
                  </Accordion>
                </div>
              ) : (
                finalizadoChecked == "programa-finalizado" && (
                  <EmptyDashboard tipo="Aún no has finalizado ningún programa"></EmptyDashboard>
                )
              )}
              {explorarChecked == "curso-explorado" && listaCursosExplorar && (
                <>
                  <div className="filtro-cursosPrograma pl-2 pr-2 flex align-items-center gap-1 pb-2">
                    <span
                      className="p-input-icon-right"
                      style={{ width: "48%" }}
                    >
                      <i className="pi pi-search" />
                      <InputZegel
                        id="correo"
                        name="correo"
                        placeholder="Buscar cursos"
                        value={busquedaCurso ? busquedaCurso : ""}
                        style={{ width: "100%", height: 40 }}
                        onChange={(e) => setBusquedaCurso(e.target.value)}
                      //onBlur={formik.handleBlur}
                      />
                    </span>
                    <MultiselectZegel
                      value={categoriaSeleccionada}
                      placeholder="Categoría"
                      options={listaCategorias}
                      optionLabel="descripcionCategoria"
                      optionValue="idCategoria"
                      style={{ width: "26%" }}
                      onChange={(e) => setCategoriaSeleccionada(e.value)}
                    ></MultiselectZegel>

                    <MultiselectZegel
                      value={ordenFiltroSeleccionado}
                      placeholder="Order por"
                      options={filtroOrden}
                      optionLabel="name"
                      onChange={(e) => setOrdenFiltroSeleccionado(e.value)}
                      style={{ width: "26%" }}
                    ></MultiselectZegel>
                  </div>
                  <div className="flex justify-content-end pl-2  pr-2 mb-3">
                    <Link
                      style={{
                        textDecorationLine: "underline",
                        fontSize: "12px",
                      }}
                      onClick={() => {
                        setBusquedaCurso(null);
                        setCategoriaSeleccionada(null);
                        setOrdenFiltroSeleccionado(null);
                      }}
                    >
                      Limpiar filtros
                    </Link>
                  </div>

                  <div className="pl-2  pr-2 mb-4">
                    <div className="flex banner-descuento-curso gap-3">
                      <div className="flex align-items-center pl-5 gap-1">
                        <div
                          className="font-bold"
                          style={{ color: "#fff", fontSize: 70 }}
                        >
                          {buscarConfiguracion(configuraciones, "DCTO_CURSOS")}
                        </div>
                        <div>
                          <div
                            className="text-5xl font-bold"
                            style={{ color: "#fff" }}
                          >
                            %
                          </div>
                          <div
                            className="text-base font-bold"
                            style={{ color: "#fff" }}
                          >
                            dto.
                          </div>
                        </div>
                      </div>
                      <div
                        className="flex align-items-center text-base"
                        style={{ color: "#fff" }}
                      >
                        Seguimos brindándote la mejor educación donde te
                        encuentres con un plataforma 100% virtual y con el
                        respaldo de Zegel.
                      </div>
                    </div>
                  </div>
                  <div
                    className="content-cursosPrograma"
                    style={{
                      paddingLeft: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                    }}
                  >
                    {listaCursosExplorar.map((item, i) => {
                      return (
                        <CardCursoExplorar
                          key={i}
                          curso={item}
                        ></CardCursoExplorar>
                      );
                    })}
                  </div>
                </>
              )}
              {explorarChecked == "programa-explorado" &&
                listaProgramasExplorar && (
                  <div
                    className="content-dashPrograma"
                    style={{ paddingLeft: "20px", paddingRight: "20px" }}
                  >
                    {listaProgramasExplorar.map((item, i) => {
                      return (
                        <CardProgramaExplorar
                          key={i}
                          programa={item}
                        ></CardProgramaExplorar>
                      );
                    })}
                  </div>
                )}
            </div>
          </div>
          {/* Mobile */}
          <div className="home-dashboard-body-mobile">
            <TabZal
              activeIndex={parseInt(indexTabPrincipal)}
              tipo="primary"
              onTabChange={(e) => setIndexTabPrincipal(e.index)}
            >
              <TabPanel header={`Activos`}>
                <TabZal
                  activeIndex={parseInt(indexTabSecundario)}
                  tipo="secondary"
                  onTabChange={(e) => setIndexTabSecundario(e.index)}
                >
                  <TabPanel
                    header={`Cursos (${cursosActivos ? cursosActivos.length : 0
                      })`}
                  >
                    {cursosActivos && cursosActivos.length > 0 ? (
                      <div
                        className="content-cursosPrograma"
                        style={{
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                        }}
                      >
                        {cursosActivos.map((item, i) => {
                          return <CardCurso key={i} curso={item}></CardCurso>;
                        })}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <div style={{ marginBottom: "150px" }}></div>
                        <EmptyDashboard tipo="Aún no has comprado"></EmptyDashboard>
                        <EmptyDashboard tipo="ningún curso"></EmptyDashboard>
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel
                    header={`Programas (${programasActivos ? programasActivos.length : 0
                      })`}
                  >
                    {programasActivos && programasActivos.length > 0 ? (
                      <>
                        <div
                          className="content-programaTab"
                          style={{
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingBottom: 0,
                            paddingTop: 20,
                          }}
                        >
                          <Accordion
                            activeIndex={0}
                            expandIcon={expandIcontemplate}
                            collapseIcon={CollapseIcontemplate}
                            className="acordeon-programas"
                          >
                            {programasActivos.map((item, i) => {
                              return (
                                <AccordionTab
                                  key={1}
                                  style={{
                                    width: "100%",
                                    paddingTop: 0,
                                    marginTop: 0,
                                  }}
                                  header={item.programa.nombre}
                                >
                                  <div
                                    className="content-Programa"
                                    style={{
                                      // paddingLeft: 8,
                                      // paddingRight: 8,
                                      paddingBottom: 8,
                                    }}
                                  >
                                    {listaCursosProgramasPersona &&
                                      listaCursosProgramasPersona
                                        .filter(
                                          (x) =>
                                            x.idPersonaPrograma ==
                                            item.idPersonaPrograma
                                        )
                                        .map((curso, j) => {
                                          return (
                                            <CardPrograma
                                              key={i}
                                              curso={curso}
                                              personaPrograma={
                                                item.idPersonaPrograma
                                              }
                                              idPrograma={item.idPrograma}
                                            ></CardPrograma>
                                          );
                                        })}
                                  </div>
                                </AccordionTab>
                              );
                            })}
                          </Accordion>
                        </div>
                      </>
                    ) : (

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <div style={{ marginBottom: "150px" }}></div>
                        <EmptyDashboard tipo="Aún no has comprado"></EmptyDashboard>
                        <EmptyDashboard tipo="ningún programa"></EmptyDashboard>
                      </div>
                    )}
                  </TabPanel>
                </TabZal>
              </TabPanel>
              <TabPanel header="Finalizados">
                <TabZal
                  activeIndex={parseInt(indexTabSecundario)}
                  tipo="secondary"
                >
                  <TabPanel
                    header={`Cursos (${cursosFianlizados ? cursosFianlizados.length : 0
                      })`}
                  >
                    {cursosFianlizados && cursosFianlizados.length > 0 ? (
                      <div
                        className="content-cursosPrograma"
                        style={{
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                        }}
                      >
                        {cursosFianlizados.map((item, i) => {
                          return <CardCurso key={i} curso={item}></CardCurso>;
                        })}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <div style={{ marginBottom: "150px" }}></div>
                        <EmptyDashboard tipo="Aún no has finalizado "></EmptyDashboard>
                        <EmptyDashboard tipo="ningún curso"></EmptyDashboard>
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel
                    header={`Programas (${programasFinalizados ? programasFinalizados.length : 0
                      })`}
                  >
                    {programasFinalizados && programasFinalizados.length > 0 ? (
                      <>
                      <div
                        className="content-programaTab"
                        style={{
                          paddingLeft: 20,
                          paddingRight: 20,
                          paddingBottom: 0,
                          paddingTop: 20,
                        }}
                      >
                        <Accordion
                          activeIndex={0}
                          expandIcon={expandIcontemplate}
                          collapseIcon={CollapseIcontemplate}
                          className="acordeon-programas"
                        >
                          {programasFinalizados.map((item, i) => {
                            return (
                              <AccordionTab
                                key={1}
                                style={{
                                  width: "100%",
                                  paddingTop: 0,
                                  marginTop: 0,
                                }}
                                header={item.programa.nombre}
                              >
                                <div
                                  className="content-Programa"
                                  style={{
                                    // paddingLeft: 8,
                                    // paddingRight: 8,
                                    paddingBottom: 8,
                                  }}
                                >
                                  {listaCursosProgramasPersona &&
                                    listaCursosProgramasPersona
                                      .filter(
                                        (x) =>
                                          x.idPersonaPrograma ==
                                          item.idPersonaPrograma
                                      )
                                      .map((curso, j) => {
                                        return (
                                          <CardPrograma
                                            key={i}
                                            curso={curso}
                                            personaPrograma={
                                              item.idPersonaPrograma
                                            }
                                            idPrograma={item.idPrograma}
                                          ></CardPrograma>
                                        );
                                      })}
                                </div>
                              </AccordionTab>
                            );
                          })}
                        </Accordion>
                      </div>
                    </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <div style={{ marginBottom: "150px" }}></div>
                        <EmptyDashboard tipo="Aún no has finalizado "></EmptyDashboard>
                        <EmptyDashboard tipo="ningún programa"></EmptyDashboard>
                      </div>
                    )}
                  </TabPanel>
                </TabZal>
              </TabPanel>

              <TabPanel header="Explorar">
                <TabZal
                  activeIndex={parseInt(indexTabSecundario)}
                  tipo="secondary"
                >
                  <TabPanel header="Cursos">
                    {listaCursosExplorar && (
                      <div
                        className="content-cursosPrograma"
                        style={{
                          paddingLeft: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                        }}
                      >
                        <div className="flex align-items-center ml-1 mr-1">
                          <span
                            className="p-input-icon-right"
                            style={{ width: "100%" }}
                          >
                            <i className="pi pi-search" />
                            <InputZegel
                              id="correo"
                              name="correo"
                              placeholder="Buscar cursos"
                              value={busquedaCurso}
                              style={{ width: "100%", height: "50px" }}
                              onChange={(e) => setBusquedaCurso(e.target.value)}
                            />
                          </span>

                          <div
                            className="flex align-items-center justify-content-center boton-filtro"
                            onClick={() => setFilterMenu(!filterMenu)}
                          >
                            <img
                              src={iconoFiltro}
                              width={"17.5px"}
                              height={"21px"}
                              for="menu"
                            ></img>
                          </div>
                        </div>
                        {filterMenu === true ? (
                          <div className="relative">
                            {" "}
                            <MultiselectZegel
                              value={categoriaSeleccionada}
                              placeholder="Categoría"
                              options={listaCategorias}
                              optionLabel="descripcionCategoria"
                              optionValue="idCategoria"
                              onChange={(e) =>
                                setCategoriaSeleccionada(e.value)
                              }
                            ></MultiselectZegel>
                            <MultiselectZegel
                              value={ordenFiltroSeleccionado}
                              placeholder="Order por"
                              options={filtroOrden}
                              optionLabel="name"
                              onChange={(e) =>
                                setOrdenFiltroSeleccionado(e.value)
                              }
                            ></MultiselectZegel>
                          </div>
                        ) : (
                          <></>
                        )}
                        {listaCursosExplorar.map((item, i) => {
                          return (
                            <CardCursoExplorar
                              key={i}
                              curso={item}
                            ></CardCursoExplorar>
                          );
                        })}
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel header="Programas">
                    {listaProgramasExplorar && (
                      <div
                        className="content-dashPrograma"
                        style={{
                          paddingLeft: "20px",
                          paddingRight: "20px",
                          paddingTop: "20px",
                        }}
                      >
                        {listaProgramasExplorar.map((item, i) => {
                          return (
                            <CardProgramaExplorar
                              key={i}
                              programa={item}
                            ></CardProgramaExplorar>
                          );
                        })}
                      </div>
                    )}
                  </TabPanel>
                </TabZal>
              </TabPanel>
            </TabZal>
          </div>
        </div>
      ) : (
        <div>
          {/* <div className="ventanaLoad" ></div>
        <div className="ventanaLoadSpinn" >
          <ProgressSpinner />
        </div> */}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
